/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimStatusCount
 */
export interface ClaimStatusCount {
    /**
     * Configured status color used for chart bars
     * @type {string}
     * @memberof ClaimStatusCount
     */
    color?: string;
    /**
     * Status template to filter claims by when opening this status
     * @type {number}
     * @memberof ClaimStatusCount
     */
    statusTemplateId: number;
    /**
     * Pipeline containing these claims
     * @type {number}
     * @memberof ClaimStatusCount
     */
    pipelineId: number;
    /**
     * Status name
     * @type {string}
     * @memberof ClaimStatusCount
     */
    status: string;
    /**
     * Number of claims with this status
     * @type {number}
     * @memberof ClaimStatusCount
     */
    count: number;
}

/**
 * Check if a given object implements the ClaimStatusCount interface.
 */
export function instanceOfClaimStatusCount(value: object): value is ClaimStatusCount {
    if (!('statusTemplateId' in value) || value['statusTemplateId'] === undefined) return false;
    if (!('pipelineId' in value) || value['pipelineId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ClaimStatusCountFromJSON(json: any): ClaimStatusCount {
    return ClaimStatusCountFromJSONTyped(json, false);
}

export function ClaimStatusCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimStatusCount {
    if (json == null) {
        return json;
    }
    return {
        
        'color': json['color'] == null ? undefined : json['color'],
        'statusTemplateId': json['statusTemplateId'],
        'pipelineId': json['pipelineId'],
        'status': json['status'],
        'count': json['count'],
    };
}

export function ClaimStatusCountToJSON(json: any): ClaimStatusCount {
    return ClaimStatusCountToJSONTyped(json, false);
}

export function ClaimStatusCountToJSONTyped(value?: ClaimStatusCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'color': value['color'],
        'statusTemplateId': value['statusTemplateId'],
        'pipelineId': value['pipelineId'],
        'status': value['status'],
        'count': value['count'],
    };
}

